import { __rest, __assign, __spreadArray } from 'tslib';
import React__default from 'react';
import { createBasketBusinessFilter, DataViewKey } from '@keepeek/commons';
import KFSearch from '../KFSearch/index.js';

var KFBasketSearch = function KFBasketSearch(_a) {
    var basketId = _a.basketId, constantActiveBusinessFilters = _a.constantActiveBusinessFilters, rest = __rest(_a, ["basketId", "constantActiveBusinessFilters"]);
    return (React__default.createElement(KFSearch, __assign({ constantActiveBusinessFilters: __spreadArray(__spreadArray([], (constantActiveBusinessFilters !== null && constantActiveBusinessFilters !== void 0 ? constantActiveBusinessFilters : []), true), [
            createBasketBusinessFilter(basketId),
        ], false), dataViewKey: DataViewKey.BASKET_DETAIL }, rest)));
};

export { KFBasketSearch as default };
//# sourceMappingURL=index.js.map
